import React from "react";
import { Whisper, Popover } from "rsuite";
import { useNavigate } from "react-router-dom";
import { MdOutlineVisibility, MdOutlineUpdate } from "react-icons/md";
import { useLazyGetAppointmentDetailsByIdQuery } from "../../State/Api/AdddocApiSlice";

const ActionCellRenderer = (props) => {
  const appointmentId = props?.data?.appointmentID;
  const userClinicId = localStorage.getItem("userClinicID");

  const navigate = useNavigate();

  const [getDetails, { data: appointmentDetails }] =
    useLazyGetAppointmentDetailsByIdQuery();

  const handleViewDetails = async () => {
    if (appointmentId && userClinicId) {
      try {
        const result = await getDetails({ appointmentId, userClinicId });

        // Log the props and fetched data
        console.log("Props Data:", props.data);
        console.log("Fetched Appointment Details:", result.data);

        // Navigate with URL parameters instead of state
        navigate(`/AppointmentDetails/${appointmentId}/${userClinicId}`, {
          state: {
            status: result.data?.status,
            details: result.data,
            appointmentData: props.data,
          },
        });
      } catch (err) {
        console.error("Failed to fetch appointment details:", err);
      }
    }
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-42">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={handleViewDetails}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdOutlineVisibility className="text-lg text-gray-500" />
        <span>View details</span>
      </div>

      {["today", "upcoming"].includes(props.data?.status?.toLowerCase()) && (
        <div
          onClick={() =>
            navigate("/RescheduleAppointment", {
              state: { appointmentData: props.data },
            })
          }
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
        >
          <MdOutlineUpdate className="text-lg text-gray-500" />
          <span>Reschedule</span>
        </div>
      )}
    </Popover>
  );

  return (
    <Whisper
      placement="autoVerticalEnd"
      trigger="click"
      speaker={renderPopover}
    >
      <button
        className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellRenderer;
